export interface Category {
  key: string;
  url: string;
  icon: string;
  image: string;
}

export const categories: Category[] = [
  {
    key: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    image:
      'https://readdy.ai/api/search-image?query=A%20pair%20of%20white%20and%20pastel%20sneakers%20standing%20on%20a%20clean%20cream%20studio%20surface%20with%20soft%20natural%20light%2C%20minimal%20editorial%20product%20photography%2C%20warm%20neutral%20tones%2C%20high%20detail%20harmonious%20composition&width=400&height=300&seq=cat-shoes-01&orientation=landscape',
  },
  {
    key: 'hoodies',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-shirt-line',
    image:
      'https://readdy.ai/api/search-image?query=A%20neatly%20folded%20oversized%20pastel%20hoodie%20sweater%20on%20a%20clean%20cream%20background%20with%20soft%20natural%20light%2C%20minimal%20editorial%20product%20photography%2C%20warm%20neutral%20tones%2C%20high%20detail&width=400&height=300&seq=cat-hoodies-01&orientation=landscape',
  },
  {
    key: 'tshirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    image:
      'https://readdy.ai/api/search-image?query=A%20stack%20of%20soft%20pastel%20cotton%20t-shirts%20folded%20on%20a%20clean%20cream%20surface%20with%20gentle%20natural%20light%2C%20minimal%20editorial%20product%20photography%2C%20warm%20neutral%20tones%2C%20high%20detail&width=400&height=300&seq=cat-tshirts-01&orientation=landscape',
  },
  {
    key: 'jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-t-shirt-2-line',
    image:
      'https://readdy.ai/api/search-image?query=A%20stylish%20lightweight%20jacket%20hung%20on%20a%20wooden%20hanger%20against%20a%20clean%20cream%20wall%20with%20soft%20natural%20light%2C%20minimal%20editorial%20product%20photography%2C%20warm%20neutral%20tones&width=400&height=300&seq=cat-jackets-01&orientation=landscape',
  },
  {
    key: 'pants',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-shopping-bag-2-line',
    image:
      'https://readdy.ai/api/search-image?query=A%20folded%20pair%20of%20casual%20pants%20and%20shorts%20arranged%20on%20a%20clean%20cream%20background%20with%20soft%20natural%20light%2C%20minimal%20editorial%20product%20photography%2C%20warm%20neutral%20tones%2C%20high%20detail&width=400&height=300&seq=cat-pants-01&orientation=landscape',
  },
  {
    key: 'headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-vip-crown-line',
    image:
      'https://readdy.ai/api/search-image?query=A%20collection%20of%20minimal%20caps%20and%20beanies%20arranged%20on%20a%20clean%20cream%20surface%20with%20soft%20natural%20light%2C%20editorial%20product%20photography%2C%20warm%20neutral%20tones%2C%20high%20detail&width=400&height=300&seq=cat-headwear-01&orientation=landscape',
  },
  {
    key: 'sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-archive-line',
    image:
      'https://readdy.ai/api/search-image?query=A%20coordinated%20matching%20outfit%20set%20of%20hoodie%20and%20sweatpants%20laid%20flat%20on%20a%20clean%20cream%20background%20with%20soft%20natural%20light%2C%20minimal%20editorial%20product%20photography%2C%20warm%20neutral%20tones&width=400&height=300&seq=cat-sets-01&orientation=landscape',
  },
  {
    key: 'underwear',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-shirt-line',
    image:
      'https://readdy.ai/api/search-image?query=Soft%20folded%20underwear%20basics%20neatly%20arranged%20on%20a%20clean%20cream%20surface%20with%20gentle%20natural%20light%2C%20minimal%20editorial%20product%20photography%2C%20warm%20neutral%20tones%2C%20high%20detail&width=400&height=300&seq=cat-underwear-01&orientation=landscape',
  },
  {
    key: 'jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    image:
      'https://readdy.ai/api/search-image?query=A%20sports%20jersey%20folded%20on%20a%20clean%20cream%20background%20with%20soft%20natural%20light%2C%20minimal%20editorial%20product%20photography%2C%20warm%20neutral%20tones%2C%20high%20detail%20harmonious%20composition&width=400&height=300&seq=cat-jersey-01&orientation=landscape',
  },
  {
    key: 'accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-vip-diamond-line',
    image:
      'https://readdy.ai/api/search-image?query=Assorted%20minimal%20accessories%20like%20watches%20and%20jewelry%20arranged%20on%20a%20clean%20cream%20surface%20with%20soft%20natural%20light%2C%20editorial%20product%20photography%2C%20warm%20neutral%20tones%2C%20high%20detail&width=400&height=300&seq=cat-accessories-01&orientation=landscape',
  },
  {
    key: 'bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-handbag-line',
    image:
      'https://readdy.ai/api/search-image?query=A%20minimal%20backpack%20and%20handbag%20placed%20on%20a%20clean%20cream%20surface%20with%20soft%20natural%20light%2C%20editorial%20product%20photography%2C%20warm%20neutral%20tones%2C%20high%20detail%20harmonious%20composition&width=400&height=300&seq=cat-bags-01&orientation=landscape',
  },
  {
    key: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-links-line',
    image:
      'https://readdy.ai/api/search-image?query=Coiled%20leather%20and%20fabric%20belts%20arranged%20on%20a%20clean%20cream%20surface%20with%20soft%20natural%20light%2C%20minimal%20editorial%20product%20photography%2C%20warm%20neutral%20tones%2C%20high%20detail&width=400&height=300&seq=cat-belts-01&orientation=landscape',
  },
  {
    key: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
    image:
      'https://readdy.ai/api/search-image?query=Elegant%20perfume%20bottles%20arranged%20on%20a%20clean%20cream%20surface%20with%20soft%20natural%20light%2C%20minimal%20editorial%20product%20photography%2C%20warm%20neutral%20tones%2C%20high%20detail%20harmonious%20composition&width=400&height=300&seq=cat-perfumes-01&orientation=landscape',
  },
  {
    key: 'other',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-2-line',
    image:
      'https://readdy.ai/api/search-image?query=Various%20small%20lifestyle%20products%20and%20gadgets%20arranged%20on%20a%20clean%20cream%20surface%20with%20soft%20natural%20light%2C%20minimal%20editorial%20product%20photography%2C%20warm%20neutral%20tones%2C%20high%20detail&width=400&height=300&seq=cat-other-01&orientation=landscape',
  },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';